import React, { useContext, useEffect } from "react";
import S from "./Table";
import { createDiffieHellmanGroup } from "crypto";

export interface TableProps {
  tableData: {
    headings: string[];
    rows: any;
  };
  skipKey?: boolean;
  reverse?: boolean;
  showIndexInfo?: boolean;
}

const Table: React.FC<TableProps> = ({
  tableData,
  skipKey = false,
  reverse = false,
  showIndexInfo = false,
}) => {
  const isArray = Array.isArray(tableData.rows);

  let rows: [string, React.ReactNode[]][] = [];

  if (isArray) {
    rows = [...tableData.rows];
  } else {
    rows = Object.keys(tableData.rows).map((key) => [key, tableData.rows[key]]);
    rows.sort((a, b) => {
      if (reverse) {
        return b[0].localeCompare(a[0]);
      } else {
        return a[0].localeCompare(b[0]);
      }
    });
  }

  // Manually render index info based on the current fond in the URL
  const renderIndexInfo = () => {
    if (typeof window === "undefined") return null;
    //check which "fond" is in the url, after "/fond/" and before the next "/"
    const url = window.location.href;
    const match = url.match(/\/fond\/([^\/]+)/);
    if (match) {
      const fondId = match[1];
      return (
        <>
          {fondId === "evolve" && "MSCI Europe Small Cap NR"}
          {fondId === "evolve-global" && "MSCI World Small Cap NR USD"}
          {fondId === "realinvest" && "Nasdaq OMX Stockholm All-Share GR SEK"}
          {fondId === "fastighet" && "FTSE EPRA Nareit Developed NR EUR"}
          {fondId === "globala-utdelare" && "MSCI World NR"}
          {fondId === "sverige-aktiv" &&
            "Nasdaq OMX Stockholm All-Share GR SEK"}
          {fondId === "yield" && "Inget index"}
          {fondId === "balans" && "Inget index"}
          {fondId === "idea" && "Inget index"}
        </>
      );
    }
    return null;
  };

  return (
    <S.TableWrapper>
      <S.TableContent>
        {tableData.headings && (
          <S.TableHeader>
            {tableData.headings.map((heading, index) => (
              <S.TableValue key={index}>
                <S.TableKey>{heading}</S.TableKey>
              </S.TableValue>
            ))}
          </S.TableHeader>
        )}
        <S.TableBody>
          {rows.map(([key, values]) => (
            <S.TableRow key={key}>
              {!skipKey && (
                <S.TableValue>
                  <S.TableKey>{key}</S.TableKey>
                </S.TableValue>
              )}
              {values.map((value, index) => (
                <S.TableValue key={index}>
                  <S.TableKey>{value ?? "-"}</S.TableKey>
                </S.TableValue>
              ))}
            </S.TableRow>
          ))}
          {showIndexInfo && (
            <S.TableRow>
              <S.TableValue>
                <S.TableKey>Jämförelseindex</S.TableKey>
              </S.TableValue>
              <S.TableValue>
                <S.TableKey>{renderIndexInfo()}</S.TableKey>
              </S.TableValue>
            </S.TableRow>
          )}
        </S.TableBody>
      </S.TableContent>
    </S.TableWrapper>
  );
};
export default Table;
